// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* API Settings: only what is specific to it.
 *
 * The field, footer and button vocabulary is ../modal-content.module.css, and
 * the key list, badges and editor box are ../llmConfigs/LlmConfigs.module.css.
 */

.VVQXSpLbXG_akLma2Zqw {
  font-family: var(--curio-font-family);
  color: var(--curio-text-primary);
}

/* The two tabs: the catalog drawers' tab strip, as a tablist. */
.eh8D_SlPIRkioLtxSCBR {
  display: flex;
  gap: 4px;
  margin: 0 0 14px;
  border-bottom: 1px solid var(--curio-border);
}

.MJduK27oJWphsQaXJgTc {
  padding: 8px 14px;
  margin-bottom: -1px;
  border: none;
  border-bottom: 2px solid transparent;
  background: none;
  font: inherit;
  font-size: var(--curio-font-size-md);
  color: var(--curio-text-secondary);
  cursor: pointer;
}

.MJduK27oJWphsQaXJgTc:hover:not(.DnggimsVfH1Cu9EQIQDB) {
  color: var(--curio-text-primary);
}

.DnggimsVfH1Cu9EQIQDB {
  border-bottom-color: var(--curio-top-bar-bg);
  color: var(--curio-text-primary);
  font-weight: 600;
}

.W8L2WQNykz6PTed2btZo {
  min-width: 0;
}

.RjFWHvpQYtpBm_hAwRS9 {
  font-weight: 400;
  text-transform: none;
  color: var(--curio-text-muted);
  letter-spacing: 0;
}

.LS9JB7crZrMlg6vgcEij {
  font-size: var(--curio-font-size-sm);
  color: var(--curio-role-published-fg);
  text-decoration: none;
  margin-top: 2px;
}

.t1hbdPwFIOwDeql7hsAC {
  color: var(--curio-text-secondary);
  font-size: var(--curio-font-size-lg);
  margin-bottom: 8px;
}

/* The local shared guest: everyone on this Curio uses the one account. */
.BQ7YQisZWHWfZboeRE1C {
  margin: 0 0 10px;
  padding: 6px 10px;
  border-radius: var(--curio-radius-sm);
  background: var(--curio-page-bg);
  color: var(--curio-text-secondary);
  font-size: var(--curio-font-size-sm);
}

/* Two fields side by side, wrapping on a narrow drawer. */
.zHt_gI8mwsGuo8avXX2n {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.zHt_gI8mwsGuo8avXX2n > * {
  flex: 1 1 140px;
}
`, "",{"version":3,"sources":["webpack://./src/components/apiSettings/ApiSettings.module.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;EACb,oCAAoC;EACpC,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4CAA4C;EAC5C,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,yEAAyE;AACzE;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;EACrC,gCAAgC;EAChC,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB","sourcesContent":["/* API Settings: only what is specific to it.\n *\n * The field, footer and button vocabulary is ../modal-content.module.css, and\n * the key list, badges and editor box are ../llmConfigs/LlmConfigs.module.css.\n */\n\n.panel {\n  font-family: var(--curio-font-family);\n  color: var(--curio-text-primary);\n}\n\n/* The two tabs: the catalog drawers' tab strip, as a tablist. */\n.tabs {\n  display: flex;\n  gap: 4px;\n  margin: 0 0 14px;\n  border-bottom: 1px solid var(--curio-border);\n}\n\n.tab {\n  padding: 8px 14px;\n  margin-bottom: -1px;\n  border: none;\n  border-bottom: 2px solid transparent;\n  background: none;\n  font: inherit;\n  font-size: var(--curio-font-size-md);\n  color: var(--curio-text-secondary);\n  cursor: pointer;\n}\n\n.tab:hover:not(.tabActive) {\n  color: var(--curio-text-primary);\n}\n\n.tabActive {\n  border-bottom-color: var(--curio-top-bar-bg);\n  color: var(--curio-text-primary);\n  font-weight: 600;\n}\n\n.tabBody {\n  min-width: 0;\n}\n\n.optional {\n  font-weight: 400;\n  text-transform: none;\n  color: var(--curio-text-muted);\n  letter-spacing: 0;\n}\n\n.keyLink {\n  font-size: var(--curio-font-size-sm);\n  color: var(--curio-role-published-fg);\n  text-decoration: none;\n  margin-top: 2px;\n}\n\n.guestNotice {\n  color: var(--curio-text-secondary);\n  font-size: var(--curio-font-size-lg);\n  margin-bottom: 8px;\n}\n\n/* The local shared guest: everyone on this Curio uses the one account. */\n.sharedNote {\n  margin: 0 0 10px;\n  padding: 6px 10px;\n  border-radius: var(--curio-radius-sm);\n  background: var(--curio-page-bg);\n  color: var(--curio-text-secondary);\n  font-size: var(--curio-font-size-sm);\n}\n\n/* Two fields side by side, wrapping on a narrow drawer. */\n.row {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.row > * {\n  flex: 1 1 140px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `VVQXSpLbXG_akLma2Zqw`,
	"tabs": `eh8D_SlPIRkioLtxSCBR`,
	"tab": `MJduK27oJWphsQaXJgTc`,
	"tabActive": `DnggimsVfH1Cu9EQIQDB`,
	"tabBody": `W8L2WQNykz6PTed2btZo`,
	"optional": `RjFWHvpQYtpBm_hAwRS9`,
	"keyLink": `LS9JB7crZrMlg6vgcEij`,
	"guestNotice": `t1hbdPwFIOwDeql7hsAC`,
	"sharedNote": `BQ7YQisZWHWfZboeRE1C`,
	"row": `zHt_gI8mwsGuo8avXX2n`
};
export default ___CSS_LOADER_EXPORT___;
